module.exports = __webpack_public_path__ + "img/s3-1.b6cf5202.svg";